import { useMemo } from 'react';

export default function useDefinitions() {
  return useMemo(() => ({
    entityName: 'Offer',
    entityNamePlural: 'Offers',
    entityNameModule: 'offer',
  }), [])
}
